import { render, staticRenderFns } from "./FilesEditor.vue?vue&type=template&id=7f5a5290&"
import script from "./FilesEditor.vue?vue&type=script&lang=js&"
export * from "./FilesEditor.vue?vue&type=script&lang=js&"
import style0 from "./FilesEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports